module.exports = __webpack_public_path__ + "img/u107.de3d0707.svg";